export const SHOP_TIRES_TAB_NAME = 'Shop By Tire Size'
export const NEED_HELP_TAB_NAME = 'Need Help?'
